<div style="background-color: black">
    <header className="header">
        <h1 className="header__heading">
            <a
                className="footer__link"
                href="https://developers.giphy.com/"
                aria-label="GIPHY Developers"
                target="_blank"
            >
                <img src="../../../../assets/images/giphy-logo.png" alt="Powered By GIPHY" />
            </a>
            <!-- <span className="header__logo">GIPHY</span> -->
        </h1>
    </header>

    <div class="search" style="margin-bottom: 15px">
        <input
            type="text"
            class="input userinput"
            style="width: 500px"
            placeholder="Search GIFs"
            [(ngModel)]="searchQuery"
            (keydown)="keyDownFunction($event)"
        />
        <button
            (click)="searchGiphy()"
            class="btn searchBtn"
            style="background: linear-gradient(45deg, rgb(153, 51, 255) 0%, rgb(255, 102, 102) 100%)"
        >
            <vng-icon name="search" [outline]="false" class="search-icon" style="color: white; margin-top: 3px"></vng-icon>
        </button>
    </div>

    <div class="container gif-results" style="overflow-y: scroll; height: 420px">
        <!-- R24: mat-grid-list/mat-grid-tile -> CSS grid; [cols]/[gutterSize]/[rowspan] map 1:1 to
             grid-template-columns / gap / grid-row: span n. -->
        <div class="giphy-grid" [style.grid-template-columns]="'repeat(' + cols + ', 1fr)'" [style.gap.px]="gutterSize">
            <div
                class="giphy-grid-tile"
                *ngFor="let imageItem of images"
                [style.grid-row]="'span ' + item.rows"
                (click)="selectGiphy(imageItem)"
            >
                <!-- Grid image item -->
                <app-grid-gallery-item
                    #item
                    style="width: 308px"
                    [image]="imageItem"
                    [rowHeight]="rowHeight"
                    [gutterSize]="gutterSize"
                >
                </app-grid-gallery-item>
            </div>
        </div>
    </div>
    <div id="giphy-search"></div>

    <footer
        className="footer"
        style="animation: 1s ease 200ms 1 normal forwards running lbWRkT; margin-top: 15px"
    >
        <a
            className="footer__link"
            href="https://developers.giphy.com/"
            aria-label="GIPHY Developers"
            target="_blank"
        >
            <img
                className="footer__image"
                src="http://www.georgewpark.com/images/codepen/giphy-attribution.png"
                alt="Powered By GIPHY"
            />
        </a>
    </footer>
</div>
